<template>
    <vx-tooltip class="vx-info-title" :title="title" :text="descriptionLocal" position="right">
        <h5 class="line-height-inherit">
            {{ title }}
            <vx-basic-icon style="vertical-align: super" size="4" class="mt-0" icon="icon-info" />
        </h5>
    </vx-tooltip>
</template>

<script>
export default {
    name: 'vx-info-title',
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    data() {
        return {}
    },
    watch: {},
    computed: {
        hasInfoText() {
            return !!this.description
        },
        descriptionLocal() {
            return this.description || 'No Description Available'
        }
    },
    methods: {},
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped></style>
